import React from 'react'
import { LineUser } from 'types/coupon'
import { LabelSemiBoldTiny } from 'components/base-ui/FontsV2'
import { User, UserImage } from './styled'

const avatarImg = `${process.env.PUBLIC_URL}/assets/dine-in/avatar.png`

function CouponOwner({ linePicture, lineDisplayName }: LineUser) {
  const profileImage = linePicture ? linePicture : avatarImg
  return (
    <User>
      <UserImage src={profileImage} alt="user" />
      <LabelSemiBoldTiny color="darkGrey">{lineDisplayName}</LabelSemiBoldTiny>
    </User>
  )
}

export default CouponOwner
